import './Footer.css'

const Footer = ()=>{

    return (
        <footer className='footer'>Created by <a href="https://github.com/yasmingsdm">Yasmin Dal Medico</a>
        </footer>
    )}

    export default Footer